import React from 'react';
function ChevronRight() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default ChevronRight;
